package app.smartcoding.realrate.platform

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.layout.positionInWindow
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.zIndex
import app.smartcoding.realrate.domain.model.AdBannerData
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLIFrameElement
import org.w3c.dom.MessageEvent
import org.w3c.dom.events.Event

@Composable
actual fun AdBannerData.AdBanner(
    modifier: Modifier,
) {
/*

    if (adSensePublisherId.isEmpty() || adSenseSlotId.isEmpty()) return

    var adHeightDp: Dp? by remember { mutableStateOf(null) }

    val htmlContent = remember(adSensePublisherId, adSenseSlotId) {
        generateAdSenseHtmlTest()
//        generateAdSenseHtml(adSensePublisherId, adSenseSlotId)
    }

    val iframe = remember {
        val element = document.createElement("iframe") as HTMLIFrameElement
        element.style.position = "absolute"
        element.style.border = "none"
        element.style.zIndex = "2147483647" // Гарантираме позиционирането над Canvas
        element
    }

    DisposableEffect(htmlContent) {
        // Добавяме base tag, за да имитираме baseUrl от предишния WebView
        val contentWithBase = htmlContent.replace("<head>", "<head><base href=\"https://checkrealrate.com/\">")
        iframe.srcdoc = contentWithBase
        document.body?.appendChild(iframe)
        
        onDispose {
            iframe.remove()
        }
    }

    DisposableEffect(Unit) {
        fun listener(event: Event) {
            if (event !is MessageEvent) return
            val data = event.data.toString()
            if (data.startsWith("AdBannerHeight:")) {
                data.removePrefix("AdBannerHeight:")
                    .toDoubleOrNull()
                    ?.takeIf { it > 0 }
                    ?.let { heightPx ->
                        println("AdBanner: Received height update: $heightPx") // Лог за дебъг
                        adHeightDp = heightPx.dp
                    }
            }
        }
        window.addEventListener("message", ::listener)
        onDispose { window.removeEventListener("message", ::listener) }
    }

    Box(
        modifier = modifier
            .fillMaxWidth()
            .run { adHeightDp?.let { height(it) } ?: height(100.dp) } // Резервна височина преди да се получи размера
            .zIndex(1000f) // Compose layer hint
            .onGloballyPositioned { coordinates ->
                val position = coordinates.positionInWindow()
                val width = coordinates.size.width
                val height = coordinates.size.height
                
                iframe.style.left = "${position.x}px"
                iframe.style.top = "${position.y}px"
                iframe.style.width = "${width}px"
                iframe.style.height = "${height}px"
            }
    )
*/
}

// language="HTML"
private fun generateAdSenseHtmlTest(): String =
    """
    <!DOCTYPE html>
    <html lang="bg">
    <head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <style>
            html, body {
                margin: 0;
                padding: 0;
                width: 100%;
                height: 100%;
                overflow: hidden;
            }
            /* Стилове за дебъг визуализацията */
            #test-container {
                width: 100%;
                height: 280px; /* Фиксирана височина за теста */
                background-color: rgba(255, 0, 0, 0.3); /* Полупрозрачно червено */
                border: 4px solid red; /* Дебел червен контур */
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                font-family: sans-serif;
                color: darkred;
                font-weight: bold;
                
                /* Важно за drag gestures: позволява скролването на страницата, 
                   ако потребителят влачи пръст върху банера */
                touch-action: pan-y; 
            }
            #timer {
                font-size: 24px;
                margin-top: 10px;
                background: white;
                padding: 5px 10px;
                border-radius: 4px;
            }
        </style>
    </head>
    <body>
        <div id="test-container" onclick="openLink()">
            <div>DEBUG MODE: Ad Space</div>
            <div id="timer">0s</div>
            <div style="font-size: 10px; margin-top: 5px;">(Click to Open)</div>
        </div>

        <script>
            // 1. Брояч (Часовник)
            let seconds = 0;
            const timerElement = document.getElementById('timer');
            setInterval(() => {
                seconds++;
                timerElement.innerText = seconds + 's';
            }, 1000);

            // 2. Функция за клик
            function openLink() {
                window.open('https://www.checkrealrate.com', '_blank');
            }

            // 3. СИМУЛАЦИЯ НА РАЗМЕР (Критично за Compose Web)
            // Изпращаме съобщението, което Compose чака, за да разпъне WebView-то.
            // Без това, WebView ще остане с height: 0px (или minHeight).
            setTimeout(() => {
                const height = document.getElementById('test-container').offsetHeight;
                console.log("Sending height to parent: " + height);
                
                // Изпращаме към Kotlin
                window.parent.postMessage("AdBannerHeight:" + height, "*");
            }, 100);
        </script>
    </body>
    </html>
    """.trimIndent()

// language="HTML"
private fun generateAdSenseHtml(publisherId: String, slotId: String): String =
    """
    <!DOCTYPE html>
    <html lang="en">
    <head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <style>
            html, body {
                margin: 0;
                padding: 0;
                width: 100%;
                overflow: hidden;
                background-color: transparent;
                touch-action: none; 
            }
            #ad-container {
                display: flex;
                justify-content: center;
                width: 100%;
            }
        </style>
    </head>
    <body>
        <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=$publisherId" crossorigin="anonymous"></script>
        
        <div id="ad-container">
            <ins class="adsbygoogle"
                 style="display:block; width: 100%;"
                 data-ad-client="$publisherId"
                 data-ad-slot="$slotId"
                 data-ad-format="auto"
                 data-full-width-responsive="true"></ins>
        </div>

        <script>
            const observer = new ResizeObserver(entries => {
                const height = document.body.scrollHeight;
                if (height > 1) 
                try {
                     if (window.adsbygoogle && window.adsbygoogle.length === 0) {
                        (adsbygoogle = window.adsbygoogle || []).push({});
                     }
                } catch (e) {}
            });
            
            observer.observe(document.body);
            
            setTimeout(() => {
                 try { (adsbygoogle = window.adsbygoogle || []).push({}); } catch (e) {}
            }, 500);
        </script>
    </body>
    </html>
    """.trimIndent()